import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { initializeApp } from 'firebase/app'
import { getFunctions } from 'firebase/functions'
// import dotenv from 'dotenv'

Vue.config.productionTip = false
// dotenv.config()

// const firebaseConfig = {
//   apiKey: process.env.VUE_APP_APIKEY,
//   authDomain: process.env.VUE_APP_AUTHDOMAIN,
//   projectId: process.env.VUE_APP_PROJECTID,
//   storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//   appId: process.env.VUE_APP_APPID
// }
const firebaseConfig = {
  apiKey: 'AIzaSyAQ9SklewMyU3uyovxXNm37cRgGKy63OGc',
  authDomain: 'snishit-amaze-cpg.firebaseapp.com',
  projectId: 'snishit-amaze-cpg',
  storageBucket: 'snishit-amaze-cpg.appspot.com',
  messagingSenderId: '230579858989',
  appId: '1:230579858989:web:a0cd16d8df3e47303552a4'
}

const app = initializeApp(firebaseConfig)
const functions = getFunctions(app)

new Vue({
  vuetify,
  functions,
  app,
  render: (h) => h(App)
}).$mount('#app')
